import React, { useEffect, useState } from "react";
import cookie from "react-cookies";
import { MessageOutlined } from "../../components/common/Icons";
import OrderTripChat from "../../components/common/OrderTripChat";
import "../../components/common/order-trip-chat.css";

const ChatApp = () => {
  const [visible, setVisible] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const quoteid = urlParams.get("quoteid") || localStorage.getItem("quoteid");
  const orderid = urlParams.get("orderid") || localStorage.getItem("orderid");
  const isdriver = urlParams.get("isdriver");
  const onTrackOrder =
    typeof window !== "undefined" &&
    window.location.pathname === "/track-order" &&
    !!orderid;

  useEffect(() => {
    try {
      if (cookie.load("quotetoken") && !isdriver) {
        const enableAudio = () => {
          new Audio("/notification.mp3").play().catch(() => {});
          document.removeEventListener("click", enableAudio);
        };
        document.addEventListener("click", enableAudio, { once: true });
      }
    } catch (error) {
      console.error("Audio error", error);
    }
  }, [isdriver]);

  const showFab =
    !visible &&
    !onTrackOrder &&
    cookie.load("quotetoken") &&
    !isdriver &&
    (quoteid || orderid) &&
    new Date().getHours() >= 8;

  return (
    <>
      {showFab && (
        <>
          <div className="trip-chat-fab-label" role="note">
            Questions about your trip?
          </div>
          <button
            type="button"
            className="trip-chat-fab-btn"
            aria-label="Open trip messages"
            onClick={() => setVisible(true)}
          >
            <MessageOutlined />
          </button>
        </>
      )}

      {visible && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            width: "100%",
            maxWidth: 420,
            zIndex: 1000001,
            background: "white",
            display: "flex",
            flexDirection: "column",
            boxShadow: "-4px 0 24px rgba(0,0,0,0.12)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "12px 16px",
              borderBottom: "1px solid #f0f0f0",
            }}
          >
            <MessageOutlined />
            <div style={{ marginLeft: 8, fontWeight: 600 }}>Trip messages</div>
            {orderid && (
              <a
                href={`/track-order?orderid=${encodeURIComponent(orderid)}&tab=messages`}
                style={{ marginLeft: "auto", fontSize: 13 }}
              >
                View order
              </a>
            )}
            {quoteid && !orderid && (
              <a
                href={`/quote?quoteid=${encodeURIComponent(quoteid)}`}
                style={{ marginLeft: "auto", fontSize: 13 }}
              >
                View quote
              </a>
            )}
            <button
              type="button"
              onClick={() => setVisible(false)}
              style={{
                marginLeft: 12,
                background: "none",
                border: "none",
                fontSize: 22,
                cursor: "pointer",
                lineHeight: 1,
              }}
              aria-label="Close messages"
            >
              ×
            </button>
          </div>
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              padding: 16,
              minHeight: 0,
            }}
          >
            <OrderTripChat
              orderid={orderid || ""}
              quoteid={quoteid || ""}
              listId="chat-messages-floating"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ChatApp;
